module.exports = {"Type":"DiagnosticTool","Disabled":true,"Fields":[{"label":"Test Number (1 to 4)","name":"text","serializeTo":"q"}],"Header":{"Color":"black","BackgroundColor":"#EE1010","Text":null}}


//////////////////
// WEBPACK FOOTER
// ./src/designer/widgets/DiagnosticTool.json
// module id = 695
// module chunks = 0